import { useState } from "react";

function useDrawer() {
    const [isOpen, setOpen] = useState(true);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return {
        isOpen,
        handleDrawerOpen,
        handleDrawerClose,
    };
}

export default useDrawer;
